@if (documentId()) {
    <app-widget-warehouse-disposition-workspace
        class="block h-full min-h-0 overflow-hidden"
        [fixedDocumentId]="documentId()"
        (documentAllocationChanged)="onDocumentAllocationChanged()"
    />
}
